import { ChevronDown,ChevronUp } from 'lucide-react';

import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import useKeymap from '@/hooks/pure/useKeymap';
import useFeedbackNavigationStore from '@/stores/Feedback/FeedbackNavigationStore';

export const FeedbackNavigationActions = ({
  toPrevFeedback,
  toNextFeedback,
  isFeedbackPage,
}: {
  toPrevFeedback: () => void;
  toNextFeedback: () => void;
  isFeedbackPage: boolean;
}) => {
  const { toPrevFeedback: globalToPrev, toNextFeedback: globalToNext } =
    useFeedbackNavigationStore((state) => ({
      toPrevFeedback: state.toPrevFeedback,
      toNextFeedback: state.toNextFeedback,
    }));

  const handlePrevFeedback = () => {
    if (isFeedbackPage) {
      toPrevFeedback();
    } else if (globalToPrev) {
      globalToPrev();
    }
  };

  const handleNextFeedback = () => {
    if (isFeedbackPage) {
      toNextFeedback();
    } else if (globalToNext) {
      globalToNext();
    }
  };

  useKeymap('KeyJ', handlePrevFeedback);
  useKeymap('KeyK', handleNextFeedback);

  return (
    <Flex a="center" g="6px">
      <IconButton
        onClick={handlePrevFeedback}
        icon={<ChevronUp size={12} />}
        tooltip="Previous feedback"
        shortcut="J"
      />
      <IconButton
        onClick={handleNextFeedback}
        icon={<ChevronDown size={12} />}
        tooltip="Next feedback"
        shortcut="K"
      />
    </Flex>
  );
};
